module.exports = __webpack_public_path__ + "static/media/mcorm-archi.842cf5aa.png";